import request from 'utils/request';

// Constants
import {
  GET_2FA_SETTINGS_URL,
  SEND_2FA_OTP_URL,
  VALIDATE_2FA_URL,
  VERIFY_2FA_URL,
} from 'constants/url';

// Types
import { GetActive2FAMethodResponseData } from './types';

export const getActive2FAMethod = async () => {
  const { url, method } = GET_2FA_SETTINGS_URL;
  const options = {
    method,
  };
  const response: GetActive2FAMethodResponseData = await request(url, options);
  return response;
};

export const validate2FA = async () => {
  const { url, method } = VALIDATE_2FA_URL;
  const options = {
    method,
  };
  const response = await request(url, options);
  return response;
};

export const verify2FAOtp = async (body: { code: string }) => {
  const { url, method } = VERIFY_2FA_URL;
  const options = {
    method,
    body: JSON.stringify(body),
  };
  const response = await request(url, options);
  return response;
};

export const send2FAOtp = async () => {
  const { url, method } = SEND_2FA_OTP_URL;
  const options = {
    method,
  };
  const response = await request(url, options);
  return response;
};
